module.exports = __webpack_public_path__ + "static/img/型2.b8a5f41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/型2.jpg
// module id = hXZF
// module chunks = 1